import { Route } from '@angular/router';

export const QrCodeRoutes: Route[] = [
  {
    path: 'qr-code',
    loadComponent: () => import('../pages/qr-code/qr-code.page'),
  },
];
